<template>
  <div class="py-8 md:py-12">
    <div class="container max-w-3xl">
      <!-- Page Header -->
      <div class="mb-8">
        <h1 class="heading-2" style="color: var(--text-primary);">
          Account Settings
        </h1>
        <p class="text-body mt-2" style="color: var(--text-secondary);">
          Manage your profile and account preferences.
        </p>
      </div>

      <!-- Profile Card -->
      <div class="card mb-6">
        <div class="card-header">
          <h2 class="card-title">
            Profile Information
          </h2>
          <p class="card-description">
            Update your personal details.
          </p>
        </div>
        <div class="card-body">
          <GeneralInformation
            :profile="profile"
            :loading="loadingProfile"
            @update="handleUpdateProfile" />
        </div>
      </div>

      <!-- Uptime Notifications Card -->
      <div class="card mb-6">
        <div class="card-header">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg flex items-center justify-center" style="background-color: var(--bg-muted);">
              <svg class="w-4 h-4" style="color: var(--text-secondary);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </div>
            <div>
              <h2 class="card-title">
                Uptime Notifications
              </h2>
              <p class="card-description">
                Get notified when your websites go down.
              </p>
            </div>
          </div>
        </div>
        <div class="card-body">
          <UptimeNotifications />
        </div>
      </div>

      <!-- Connected Accounts Card -->
      <div class="card">
        <div class="card-header">
          <h2 class="card-title">
            Connected Accounts
          </h2>
          <p class="card-description">
            Link external services to your account.
          </p>
        </div>
        <div class="card-body">
          <ConnectedAccounts />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { hideLoadingSpinner } from '~/javascript/utils/hide_loader.js'
import { useProfileData } from '~/javascript/composables/use_profile_data'

// Import profile components
import ConnectedAccounts from './components/connected_accounts.vue'
import GeneralInformation from './components/general_information.vue'
import UptimeNotifications from './components/uptime_notifications.vue'

// Composables
const {
  profile,
  loadingProfile,
  fetchProfile,
  updateProfile
} = useProfileData()

// Event handlers
const handleUpdateProfile = async(data) => {
  try {
    await updateProfile(data)
  } catch (error) {
    console.error('Failed to update profile:', error)
  }
}

// Lifecycle
onMounted(async() => {
  hideLoadingSpinner()

  try {
    await fetchProfile()
  } catch (error) {
    console.error('Failed to load profile data:', error)
  }
})
</script>
